import { Box, Grid, Typography } from "@mui/material";

import CollaborationList from "./CollaborationList";

const Collaboration = () => {
  return (
    <Box
      component="section"
      pt={{ xs: 0, md: 8, lg: 12.5 }}
      pb={{ xs: 7.5, md: 8, lg: 12.5 }}
    >
      <Box maxWidth={1520} px={{ xs: 2, sm: 3 }} mx="auto">
        <Typography
          variant="h2"
          mb={{ xs: 2, md: 3 }}
          textAlign={{ xs: "start", md: "center" }}
        >
          Empowering Your Business with Future-Forward Technology
        </Typography>
        <Typography
          variant="subtitle1"
          component="p"
          color="text.secondary"
          textAlign={{ xs: "start", md: "center" }}
          mb={{ xs: 4, md: 10 }}
        >
          Trackmate installers are on the cutting edge of tracking technology, empowering the world with advanced solutions that drive success.
        </Typography>

        <Grid container spacing={{ xs: 4, md: 5, lg: 9, xl: 17.5 }}>
          <Grid item xs={12} md={6} lg={6.42} width="100%">
            <CollaborationList />
          </Grid>

          <Grid item xs={12} md={6} lg={5.58}>
            <Box height="100%" display="flex" alignItems="center">
              <Typography
                variant="body1"
                fontWeight={{ xs: 400, md: 600 }}
                fontSize={{ xs: "0.875rem", md: "1.25rem" }}
                color="text.primary"
              >
                As a Trackmate installer, you are part of an elite group dedicated to optimizing vehicle, equipment, and asset tracking at affordable prices. We provide you with everything you need to sell successfully, driving value and improving customer loyalty every step of the way.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Collaboration;
